import './Tool.less';
import Icon from '@/components/iconfont/Icon.jsx';

import { useDrawer } from '@/hooks/DrawerHooks.js';
import { useNavigate } from 'react-router-dom';
import { useRef, useCallback, useState, useEffect } from 'react';

import { useWebSocket } from '@/hooks/useWebSocket.js';
import { MessageEventType } from '@/utils/socket.js';
// 导入上传工具类
import { VideoProjectUploader } from '@/utils/uppyUpload.js';
import { CheckEquity } from '@/utils/CheckEquity.js';
// 导入自定义Icon组件
import { createProject } from '@/api/upload.js';
import { userService, projectController } from '@/api/index';
import { captureVideoFrame } from '@/utils/media.js';
import message from '@/utils/message.jsx';
import { generateProjectName } from '@/utils/recordMedia.js';
import { getToken } from '@/utils/cookie';

import LoginComponent from '@/components/loginComponent/LoginComponent';

const videoAccept = {
  accept: '.mp4',
  text: 'MP4 format. Less than 1G.',
  maxSize: 1024 * 1024 * 1024, // 1GB
};
export default function Tool() {
  //   const navigate = useNavigate();
  const [loginFlag, setLoginFlag] = useState(false);
  const [userDetailUpdate, setUserDetailUpdate] = useState(0);

  return (
    <div className="upload_page_box">
      <UploadComponent
        setLoginFlag={setLoginFlag}
        userDetailUpdate={userDetailUpdate}
        setUserDetailUpdate={setUserDetailUpdate}
      />
      {loginFlag && (
        <LoginComponent
          loginFlag={loginFlag}
          setLoginFlag={setLoginFlag}
          userDetailUpdate={userDetailUpdate}
          setUserDetailUpdate={setUserDetailUpdate}
        />
      )}
    </div>
  );
}

function UploadComponent({ setLoginFlag, userDetailUpdate }) {
  const { setIsSubscribeOpen, setSubscribeTitle } = useDrawer();
  const navigate = useNavigate();
  const { accept, text, maxSize } = videoAccept;
  const [videoUrl, setVideoUrl] = useState(null);
  const [fileData, setFileData] = useState(null);
  const [uploadFlag, setUploadFlag] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [progressNum, setProgressNum] = useState(0);
  const [featureStatus, setFeatureStatus] = useState('');
  const [userData, setUserData] = useState({});
  const UploadRef = useRef(null);
  const [createProjectId, setCreateProjectId] = useState('');

  useWebSocket(
    'RETRY_SUCCESS',
    useCallback(() => {
      if (createProjectId) {
        getProjectDetail();
      }
    }, [createProjectId]),
  );

  useWebSocket(
    MessageEventType.SENTENCE_GENERATED,
    useCallback(
      ({ projectId }) => {
        if (projectId === createProjectId) {
          sessionStorage.setItem('projectItem', JSON.stringify({ id: projectId }));
          sessionStorage.removeItem('feature');
          if (featureStatus === 'auto-captions') {
            sessionStorage.setItem('activetab', 'captions');
          }
          navigate('/edit');
        }
      },
      [createProjectId, featureStatus],
    ),
  );

  useEffect(() => {
    // auto-captions //字幕
    // video-transcribe //转录
    const feature = new URLSearchParams(window.location.search).get('feature');
    if (!feature) {
      if (sessionStorage.getItem('feature')) {
        setFeatureStatus(sessionStorage.getItem('feature'));
      } else {
        if (getToken()) {
          navigate('/home');
        } else {
          navigate('/login');
        }
      }
    } else {
      setFeatureStatus(feature || '');
      sessionStorage.setItem('feature', feature);
    }
    if (getToken()) {
      getUserDetail();
    }
  }, []);
  useEffect(() => {
    if (userDetailUpdate > 0) {
      getUserDetail();
    }
  }, [userDetailUpdate]);
  const getProjectDetail = async () => {
    try {
      const res = await projectController.detail({
        projectId: createProjectId,
      });
      if (res.code === 0) {
        console.log(res);
        if (res.data.projectDetail.id === createProjectId && res.data.projectDetail.state === 2) {
          sessionStorage.setItem('projectItem', JSON.stringify({ id: res.data.projectDetail.id }));
          sessionStorage.removeItem('feature');
          if (featureStatus === 'auto-captions') {
            sessionStorage.setItem('activetab', 'captions');
          }
          navigate('/edit');
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getUserDetail = async () => {
    try {
      const res = await userService.userDetail();
      if (res?.code === 0) {
        console.log(res);
        setUserData(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // 上传进度回调
  const handleProgress = (val) => {
    setProgressNum(val);
  };

  // 处理文件选择
  const handleUploadAvatar = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      message.info('Please select video file');
      return;
    }
    const url = URL.createObjectURL(file);
    setVideoUrl(url);
    const allowedExtensions = accept.replace(/\./g, '').split(',');
    const fileExtension = file.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      message.warning('Please upload an MP4 file');
      return;
    }
    if (file.size > maxSize) {
      message.warning('Please upload a file smaller than 1GB');
      return;
    }
    setFileData(file);
  };

  const duration = useRef(0);
  const uploadSnapshot = useCallback(async (file) => {
    const url = URL.createObjectURL(file);
    let video = document.createElement('video');
    video.muted = true;
    video.autoplay = true;
    await new Promise((resolve) => {
      video.addEventListener('canplay', resolve, {
        once: true,
      });
      video.src = url;
      video.play();
    });
    duration.current = Math.floor(video.duration * 1000);
    const imageBlob = await captureVideoFrame(video);
    video.src = '';
    video.load();
    video = null;
    URL.revokeObjectURL(url);
    return imageBlob;
  }, []);
  const checkProjectPermissions = () =>
    CheckEquity({ userData, type: 'storage' }) && CheckEquity({ userData, type: 'transcript' });
  // 处理文件上传
  const handleUpload = async () => {
    if (!fileData) {
      UploadRef.current.click();
      return;
    }
    if (!getToken()) {
      setLoginFlag(true);
      return;
    }
    if (!checkProjectPermissions()) {
      if (!CheckEquity({ userData, type: 'storage' })) {
        setSubscribeTitle('Your storage space has been used up');
      }
      if (!CheckEquity({ userData, type: 'transcript' })) {
        setSubscribeTitle('Your AI Transcription has been used up');
      }
      setIsSubscribeOpen('open');
      return;
    }
    setUploadFlag(true);
    handleProgress(0);
    const imageBlob = await uploadSnapshot(fileData);
    const uploader = new VideoProjectUploader(fileData, imageBlob);
    uploader.on('progress', handleProgress);
    uploader.on('success', ({ stream, thumbnail }) => {
      createProject({
        name: generateProjectName('Video'),
        duration: duration.current,
        thumbnailUpload: {
          uploadId: thumbnail.uploadId,
          completedParts: thumbnail.eTags,
        },
        streams: [
          {
            upload: {
              uploadId: stream.uploadId,
              completedParts: stream.eTags,
            },
            type: 1,
            zIndex: 1,
          },
        ],
        type: 1,
      })
        .then((res) => {
          if (res.code === 0) {
            console.log(res);
            setCreateProjectId(res.data);
            setUploadSuccess(true);
          } else {
            throw new Error(res.msg);
          }
        })
        .catch(() => {
          setUploadFlag(false);
          message.error('Create project failed, please try again', {
            id: 'upload-video-project-failed',
          });
        });
    });
    uploader.on('failed', () => {
      uploader.retry();
    });
    uploader.on('retry-failed', () => {
      setUploadFlag(false);
      message.error('Upload failed, please try again', {
        id: 'upload-video-project-failed',
      });
    });
    uploader.upload();
  };
  return (
    <div className="upload_component_box">
      <div className="upload_component">
        <div className="title">
          {featureStatus === 'video-transcribe' && 'Transcribe a video to text'}
          {featureStatus === 'auto-captions' && 'Auto add captions to video'}
        </div>
        <div className="upload_box">
          {fileData ? (
            <AlreadyUploaded
              fileData={fileData}
              videoUrl={videoUrl}
              uploadFlag={uploadFlag}
              uploadSuccess={uploadSuccess}
              featureStatus={featureStatus}
              progressNum={progressNum}
            />
          ) : (
            <NotUploaded text={text} />
          )}
          {!uploadFlag && !uploadSuccess && (
            <input
              ref={UploadRef}
              onChange={handleUploadAvatar}
              type="file"
              accept={accept}
              className="file-input file-input-bordered file-input-xs uploadinput"
            />
          )}
        </div>
        <div className="btnbox">
          {uploadFlag ? (
            <button className="btn btn-primary btn-sm uploading_btn" disabled>
              <div className="spot_box">
                {featureStatus === 'video-transcribe' && 'Transcribing'}
                {featureStatus === 'auto-captions' && 'Processing'}
                <span className="spot_list">
                  <span className="spot">·</span>
                  <span className="spot">·</span>
                  <span className="spot">·</span>
                </span>
              </div>
            </button>
          ) : (
            <>
              <button className="btn btn-primary btn-sm" onClick={handleUpload}>
                Upload
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// 未上传状态的组件
function NotUploaded({ text }) {
  return (
    <div className="not_uploaded">
      <Icon name="icon-upload" className="icon" />
      <div className="upload_text">
        Drop your file here, or&nbsp;
        <span>click to browse</span>
      </div>
      <div className="rules">{text}</div>
    </div>
  );
}

// 已上传状态的组件
function AlreadyUploaded({
  fileData,
  videoUrl,
  uploadFlag,
  progressNum,
  uploadSuccess,
  featureStatus,
}) {
  return (
    <div className="already_uploaded">
      <video src={videoUrl} muted crossOrigin="anonymous" className="file_input_img"></video>
      <div className="file_name">{fileData?.name}</div>
      {!uploadSuccess && (
        <div>
          {uploadFlag ? (
            <progress
              className="progress progress-primary w-56"
              value={progressNum}
              max="1"></progress>
          ) : (
            <button className="btn btn-sm">Re-upload</button>
          )}
        </div>
      )}
      {uploadSuccess && (
        <div className="uploadsuccess_box">
          {featureStatus === 'video-transcribe' && (
            <>
              <span className="loading loading-spinner loading-xs"></span>
              Transcribing might take a while, please wait
            </>
          )}
          {featureStatus === 'auto-captions' && (
            <>
              <span className="loading loading-spinner loading-xs"></span>
              Processing might take a while, please wait
            </>
          )}
        </div>
      )}
    </div>
  );
}
